import styled from "styled-components";
import { queries } from "../../config";

export const Container = styled.div`
 padding: 2rem;
`